<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">{{title}}</h1>
    </section>

    <section id="body">
      <form [formGroup]="addDiscountForm" (ngSubmit)="saveChanges(addDiscountForm.value)">
        <mat-card>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Código de cupón</mat-label>
                <input matInput formControlName="code" required>
                <mat-error *ngIf="addDiscountForm.controls['code'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Descripción</mat-label>
                <input matInput formControlName="description" required>
                <mat-error *ngIf="addDiscountForm.controls['description'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex=50>
              <mat-form-field appearance="outline">
                <mat-label>Valor mínimo del carrito</mat-label>
                <input matInput type="number" formControlName="minValue">
                <mat-error *ngIf="addDiscountForm.controls['minValue'].hasError('min')">
                  El valor debe ser mayor a 0.
                </mat-error>
                <mat-hint>Opcional</mat-hint>
              </mat-form-field>
            </div>
            <div fxFlex=50>
              <mat-form-field appearance="outline">
                <mat-label>Tipo de descuento</mat-label>
                <mat-select formControlName="type" required>
                  <mat-option *ngFor="let option of discountType" [value]="option.value">
                    {{option.viewValue}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="addDiscountForm.controls['type'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Valor de descuento</mat-label>
                <input matInput type="number" formControlName="value" required>
                <mat-error *ngIf="addDiscountForm.controls['value'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
                <mat-error *ngIf="addDiscountForm.controls['value'].hasError('min')">
                  El valor debe ser mayor a 0.
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="24">
              <mat-form-field appearance="outline">
                <mat-label>Válido hasta</mat-label>
                <input matInput [min]="minDate" [matDatepicker]="calendar" formControlName="maxDate"
                  (dateInput)="inpuDateTo($event)">
                <mat-datepicker-toggle matSuffix [for]="calendar"></mat-datepicker-toggle>
                <mat-datepicker #calendar></mat-datepicker>
                <mat-hint>Opcional</mat-hint>
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Maximo de descuento</mat-label>
                <input matInput type="number" formControlName="upTo">
                <mat-error *ngIf="addDiscountForm.controls['upTo'].hasError('min')">
                  El valor debe ser mayor a 0.
                </mat-error>
                <mat-hint>Opcional</mat-hint>
              </mat-form-field>
            </div>
            <div fxFlex="25">
              <mat-form-field appearance="outline">
                <mat-label>Estado</mat-label>
                <mat-select formControlName="status" required>
                  <mat-option *ngFor="let option of status" [value]="option.value">
                    {{option.viewValue}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="addDiscountForm.controls['status'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Seleccionar tiendas</mat-label>
                <mat-select formControlName="storeList" multiple required>
                  <mat-option *ngFor="let store of allStores" [value]="store.cdStore">{{store.dsName}}</mat-option>
                </mat-select>
                <mat-error *ngIf="addDiscountForm.controls['storeList'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50">
              <mat-form-field appearance="outline">
                <mat-label>Aplicar descuento sobre el envío</mat-label>
                <mat-select formControlName="onDeliver" required>
                  <mat-option *ngFor="let option of discountOnDeliver" [value]="option.value">
                    {{option.viewValue}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="addDiscountForm.controls['onDeliver'].hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
        <br>
        <div fxLayout="row" fxLayoutAlign="start center">
          <button type="submit" [disabled]="!addDiscountForm.valid" mat-raised-button class="save-changes">GUARDAR
            CAMBIOS</button>
          <button routerLink="/discount-management" mat-raised-button class="cancel-changes">CANCELAR</button>
        </div>
      </form>
    </section>

  </div>
</div>